module.exports = __webpack_public_path__ + "img/interface_video_settings.eb932a38.png";